import React, {Fragment, useState} from 'react';
import {Button, Checkbox, Modal, Table} from "semantic-ui-react";
import DocumentTypeCell from "./controls/docTypeCell";
import moment from "moment";
// import AddFileModal from "./addFileModal";
import {apiDownload, apiPost} from "../../../../services/apiClient";
import {toast} from "react-toastify";
import {downloadFile} from "../../../../services/files";
import {getRoles} from "../../../../services/userRights";
import ConfirmModal from "../../../../components/Modals/ConfirmModal";
import {print} from "../../../../services/print";

const DocsTab = ({form, reload, documents, isModal}) => {

    const viewBtns = (getRoles() || []).includes('Coordinator');

    const [selectRows, setSelectRows] = useState([]);
    // const [openModal, setOpenModal] = useState(false);
    const [confirmModal, setConfirmModal] = useState(false);

    const getDownloadUrl = (document) => {
        let fileUrl = getApiBaseUrl() + "parcels/documents/file/" + document.key + "/download";
        return fileUrl;
    }

    const selectedFiles = documents.filter(doc => (selectRows.length ? selectRows : documents.map(d => d.id)).includes(doc.id));

    // const deleteFiles = () => {
    //     selectRows.length ? setConfirmModal({
    //         open: true,
    //         label: 'Удаление документов',
    //         children: `Вы уверены, что хотите удалить документ${selectedFiles.length > 1 ? 'ы' : ''} (${selectedFiles.map(d => d.fileName).join(', ')})?`,
    //         onConfirm: () => {
    //             apiPost(`parcels/documents/${form.id}/files/delete`, {ids: selectRows.length ? selectRows : documents.map(d => d.id)})
    //                 .then(() => {
    //                     reload();
    //                     setSelectRows([]);
    //                 })
    //                 .catch(err => {
    //                     toast.error(err.message || 'Произошла ошибка');
    //                     console.log(err);
    //                 });
    //         }
    //     }) : toast.error('Пожалуйста, выберите документы')
    //
    // }

    const downloadFiles = () => {
        selectRows.length ? apiDownload(`parcels/documents/files/download`, {keys: selectedFiles.map(d => d.key)})
            .then(d => downloadFile(d))
            .catch(err => {
                toast.error(err.message || 'Произошла ошибка');
                console.log(err);
            }): toast.error('Пожалуйста, выберите документы')
    }

    const onChangeSelectRows = (id) => {
        id ? setSelectRows(prevState => {
            let newState = [...prevState];
            newState = newState.includes(id) ? newState.filter(i => i !== id) : [...newState, id];
            return newState;
        }) : setSelectRows(prevState => (prevState.length || !documents) ? [] : documents.map(d => d.id));
    }

    const printDocument = (document) => {
        print({
            url: getDownloadUrl(document),
            contentType: document.contentType
        });
    }

    const tableRow = (document, index) => {
        return <Table.Row key={"row_" + index}>
            <Table.Cell className='table-cell_mini'>
                <Checkbox
                    checked={selectRows.includes(document.id)}
                    onChange={() => onChangeSelectRows(document.id)}
                />
            </Table.Cell>
            <Table.Cell>
                <a href={getDownloadUrl(document)}>{document.fileName}</a>
            </Table.Cell>
            <Table.Cell>
                <DocumentTypeCell
                    parcelId={form.id}
                    documentId={document.id}
                    value={document.documentType}
                    items={document.allDocumentTypes ? document.allDocumentTypes.entries : []}
                    isEditable={document.isTypeEditable}
                />
            </Table.Cell>
            <Table.Cell>
                {document.documentNumber}
            </Table.Cell>
            <Table.Cell>
                {moment(document.createdAt).format('DD.MM.YYYY')}
            </Table.Cell>
            <Table.Cell textAlign='right'>
                <a role='button' onClick={() => printDocument(document)} className="print-icon m-r-15" >
                    <span className="glyphicon glyphicon-print"></span> Печать
                </a>
            </Table.Cell>
        </Table.Row>
    }

    const table = <Table>
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell className='table-cell_mini'>
                    <Checkbox
                        checked={selectRows.length === documents.length}
                        onChange={() => onChangeSelectRows()}
                    />
                </Table.HeaderCell>
                <Table.HeaderCell>Документ</Table.HeaderCell>
                <Table.HeaderCell>Тип</Table.HeaderCell>
                <Table.HeaderCell>Номер</Table.HeaderCell>
                <Table.HeaderCell>Дата</Table.HeaderCell>
                <Table.HeaderCell/>
            </Table.Row>
        </Table.Header>
        <Table.Body>
            {documents && documents.map((row, index) => (
                tableRow(row, index)
            ))}
            {(!documents || !documents.length) && <Table.Row>
                <Table.Cell colSpan='6' textAlign='center'>
                    Документов нет
                </Table.Cell>
            </Table.Row> }
        </Table.Body>
    </Table>
    const btns = <div className='docs-table__btns'>
        {/*{viewBtns && <Button onClick={deleteFiles} className='btn_border_red'>*/}
        {/*    Удалить*/}
        {/*</Button>}*/}
        {viewBtns && <Button onClick={downloadFiles} className='btn_border_blue'>
            Скачать
        </Button>}
        {/*<Button onClick={()=>setOpenModal(true)} className='modal__actions_yes'>*/}
        {/*    Добавить*/}
        {/*</Button>*/}
        {/*<AddFileModal*/}
        {/*    id={form.id}*/}
        {/*    onClose={() => setOpenModal(false)}*/}
        {/*    open={openModal}*/}
        {/*    reload={reload}*/}
        {/*/>*/}
    </div>

    return (
        <div className='docs-table'>
            {
                isModal ? <Fragment>
                    <Modal.Content className='modal__content'>
                        {table}
                    </Modal.Content>
                    <Modal.Actions className='modal__actions'>
                        {btns}
                    </Modal.Actions>
                </Fragment> : <Fragment>
                    {table}
                    {btns}
                </Fragment>
            }
            {confirmModal && <ConfirmModal
                open={confirmModal.open}
                label={confirmModal.label}
                setOpen={() => setConfirmModal(null)}
                onConfirm={confirmModal.onConfirm}
                children={confirmModal.children}
            />}
        </div>
    );
};

export default DocsTab;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/tabs/docsTab.jsx